import { Injectable } from '@angular/core';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { PermissionService } from 'src/app/auth/services/permission.service';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { DISPLAY_ACCESS } from 'src/app/auth/types/access-level';
import { CurrentPlanService } from 'src/app/components/plans/current-plan.service';
import { PlansService } from 'src/app/components/plans/plans.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyAccessService {
  constructor(
    private currentPlanService: CurrentPlanService,
    private plansService: PlansService,
    private userStateService: UserStateService,
    private companyStateService: CompanyStateService,
    private permissionService: PermissionService,
  ) {}

  get isEnterpriseOrUnlimited(): boolean {
    const plan = this.currentPlanService.currentPlan;
    return (
      this.plansService.isUnlimitedPlan(plan) ||
      this.plansService.isEnterprisePlan(plan)
    );
  }

  get accessCompanyLicenses(): boolean {
    const company = this.companyStateService.getCopyOfSelectedCompany();

    return (
      (this.userStateService.hasRole('sa') ||
        this.userStateService.hasRole('ua')) &&
      this.currentPlanService.isPlanActive() &&
      (this.isEnterpriseOrUnlimited || this.currentPlanService.isOnTrial()) &&
      !this.currentPlanService.isParentPlan() &&
      (!company.allocatedFromCompanyId ||
        company.allocatedFromCompanyId === company.id)
    );
  }

  /**
   * Who may see the company integrations sections. Catalog entries further
   * restrict visibility via `requireRole` (CAP Alerts includes `da`; the rest
   * are `ua sa` only).
   */
  get accessCompanyIntegrations(): boolean {
    return (
      this.userStateService.hasPermission('sa ua') ||
      this.permissionService.hasAccess(DISPLAY_ACCESS.FULL_ACCESS)
    );
  }
}
